import i18n from 'modules/core/lib/i18n'

export default function surveysAnonymous(list: string[]): string[] {
  return list.map((value: string) => {
    switch (value) {
      case '0':
        return i18n.t(
          'custom_reports.especial_filters.surveys_anonymous_selector.options.non_anonymous'
        )

      case '1':
        return i18n.t(
          'custom_reports.especial_filters.surveys_anonymous_selector.options.anonymous'
        )

      default:
        return ''
    }
  })
}
